import { ColorStatusType } from "@/constants/colors.constants";
import { ChipStyle } from "../common.model";
import { TablePaginationFilter } from "@/models/table.model";

export interface CustomerTask {
	id: string;
	state: string;
	category: string;
	type: string;
	subType: string;
	createdBy: string;
	createdAt: string;
	isExpanded?: boolean;
}

export interface CustomerTaskDetail extends CustomerTask {
	assignedTo: string;
	description: string;
	contact: string;
	otrsQueueName: string;
	closedBy?: string;
	closedAt?: string;
	closedDescription?: string;
}

export interface CustomerJiraTicketChangelogDto {
	author: string;
	createdAt: string;
	field: string;
	fromValueString: string;
	toValueString: string;
}

export interface CustomerJiraTicketCommentDto {
	author: string;
	createdAt: string;
	description: string;
}

export interface CustomerJiraTicketAppointmentDto {
	code: string;
	madeOn: string;
	t4wStatus: string;
	description: string;
	solution: string;
	changelog: CustomerJiraTicketChangelogDto[];
}

export interface CustomerJiraTicketDto {
	code: string;
	type: string;
	sid: string;
	status: string;
	schamanDiagnosis: string;
	description: string;
	product: string;
	appointment?: CustomerJiraTicketAppointmentDto;
	changelog: CustomerJiraTicketChangelogDto[];
	comments: CustomerJiraTicketCommentDto[];
	createdAt: string;
	resolvedAt: string;
	resolvedLabel: string;
}

export interface CustomerJiraTicketsFiltersDto extends Partial<TablePaginationFilter> {
	status?: string;
}

enum TaskStates {
	ACKNOWLEDGED = "Acknowledged",
	IN_PROGRESS = "InProgress",
	NEW = "New",
	RESOLVED = "Resolved"
}

export const TaskStateConfig: Record<TaskStates, ChipStyle> = {
	[TaskStates.ACKNOWLEDGED]: {
		color: ColorStatusType.GREY,
		background: ColorStatusType.GREY_LIGHT
	},
	[TaskStates.NEW]: {
		color: ColorStatusType.GREY,
		background: ColorStatusType.GREY_LIGHT
	},
	[TaskStates.IN_PROGRESS]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.GREY
	},
	[TaskStates.RESOLVED]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.GREEN_LIGHT
	}
};
